export default "__VITE_ASSET__85bb121e__"